import { render, staticRenderFns } from "./aiAdmin.vue?vue&type=template&id=4faae14b&scoped=true"
import script from "./aiAdmin.vue?vue&type=script&lang=js"
export * from "./aiAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faae14b",
  null
  
)

export default component.exports